export default __webpack_public_path__ + "static/media/car.614f7ac2.svg";